export enum TeamType {
  SINGLE = 0,
  TRIATLON_RELAY = 2,
  TEAM_TWO_MEMBERS = 11,
  TEAM_THREE_MEMBERS = 12,
  TEAM_FOUR_MEMBERS = 13,
  TEAM_FIVE_MEMBERS = 14,
  TEAM_SIX_MEMBERS = 15,
  TEAM_SEVEN_MEMBERS = 16,
  TEAM_EIGHT_MEMBERS = 17,
  TEAM_NINE_MEMBERS = 18,
  TEAM_TEN_MEMBERS = 19,
  TEAM_NO_MEMBERS_NEEDED = 99
}

export function getTeamMemberCount(teamType?: TeamType): number {
  switch (teamType) {
    case TeamType.SINGLE:
      return 0;
    case TeamType.TRIATLON_RELAY:
      return 3;
    case TeamType.TEAM_TWO_MEMBERS:
      return 2;
    case TeamType.TEAM_THREE_MEMBERS:
      return 3;
    case TeamType.TEAM_FOUR_MEMBERS:
      return 4;
    case TeamType.TEAM_FIVE_MEMBERS:
      return 5;
    case TeamType.TEAM_SIX_MEMBERS:
      return 6;
    case TeamType.TEAM_SEVEN_MEMBERS:
      return 7;
    case TeamType.TEAM_EIGHT_MEMBERS:
      return 8;
    case TeamType.TEAM_NINE_MEMBERS:
      return 9;
    case TeamType.TEAM_TEN_MEMBERS:
      return 10;
    case TeamType.TEAM_NO_MEMBERS_NEEDED:
      return 0;
    default:
      return 0;
  }
}

